module.exports = __webpack_public_path__ + "src/assets/img/success@2x.e4929e57.png";